import { render, staticRenderFns } from "./DateTimeLabel.vue?vue&type=template&id=762f8508&scoped=true&"
import script from "./DateTimeLabel.vue?vue&type=script&lang=ts&"
export * from "./DateTimeLabel.vue?vue&type=script&lang=ts&"
import style0 from "./DateTimeLabel.vue?vue&type=style&index=0&id=762f8508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762f8508",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('762f8508')) {
      api.createRecord('762f8508', component.options)
    } else {
      api.reload('762f8508', component.options)
    }
    module.hot.accept("./DateTimeLabel.vue?vue&type=template&id=762f8508&scoped=true&", function () {
      api.rerender('762f8508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Account/view/vue/components/DateTimeLabel.vue"
export default component.exports